<template>
  <div class="row bgc-wrapper margin-top-42">
    <div class="col-12 traveller-heading">
      <div class="row">
        <div>
          <button
            type="button"
            class="expand-form-button pt-1"
            data-toggle="collapse"
            aria-label="Expand Inspection Details"
            data-target="#inspectionDetails"
          >
            <img alt="Toggle Inspection Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <div class="col-6 p-0">
              <h3>Inspection Details</h3>
        </div>
      </div>
    </div>
    <div class="collapse show col-12 bgc-form-box" id="inspectionDetails">
      <div class="row">
        <!--Inspection Type starts-->
        <div class=" col-lg-3 col-md-3 col-sm-6 mt-4 p-0">
          <float-label label="Inspection Type*" :fixed='isFloat(inspectionData.inspectionType.value)'>
            <select
              class="form-control inspection-type"
              v-model="inspectionData.inspectionType.value"
              :class="{ 'bgc-error-field': inspectionData.inspectionType.errorText!=='' }"
              v-evolvews="inspectionData.inspectionType"
              :disabled="isModify"
            >
              <option value selected disabled hidden>Inspection Type*</option>
              <option v-for="option in inspectionTypeList" :key="option.code" :value="option.code">{{option.name}}</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="inspectionData.inspectionType.errorText!==''"
          >{{inspectionData.inspectionType.errorText}}</span>
        </div>
        <!--Inspection Type ends-->
        <!--Inspection Plan Date starts-->
        <div class=" col-lg-3 col-md-3 col-sm-6 mt-4 p-0">
          <float-label label="Inspection Plan Date*" :fixed='isFloat(inspectionData.inspectionPlanDate.value)'>
            <datepicker
              v-model="inspectionData.inspectionPlanDate.value"
              id="inspection_plan_date"
              :typeable="true"
              :disabledDates="disablePastYears"
              format="dd/MM/yyyy"
              :input-class="isInputError(inspectionData.inspectionPlanDate.errorText)"          
              @datePickerBlurred="checkError(inspectionData.inspectionPlanDate,false)"
              placeholder="Inspection Plan Date*"
            ></datepicker>
          </float-label>
          <span
            class="error-text"
            v-if="inspectionData.inspectionPlanDate.errorText!==''"
          >{{inspectionData.inspectionPlanDate.errorText}}</span>
        </div>
        <!--Inspection Plan Date ends-->
        <!--IMD contact number starts-->
        <div class=" col-lg-3 col-md-3 col-sm-6 mt-4 p-0">
          <float-label label="IMD Contact number" :fixed='isFloat(inspectionData.imdContactNumber.value)'>
            <input
              type="text"
              placeholder="IMD Contact number"
              class="form-control"
              maxlength="12"
              v-on:keydown="onlyNumber"
              :disabled="isModify"
              v-model="inspectionData.imdContactNumber.value"
            />
          </float-label>
        </div>
      </div>
      <div class="row">
        <!--Send Inspection Link to Customer starts-->
        <div class="form-group col-lg-3 col-md-5 col-sm-6 p-0">
          <input
            type="radio"
            class="input-radio bgc-radio"
            name="preInspecType"
            id="preinspectionlinkcustomer"
            v-model="inspectionData.typeOfInspection"
            value="inspectionLinkToCustomer"
            :disabled="!((pinStatus == 'PIN Generated, Agency Alloted' || pinStatus == '') && fetchedType!='allocToInspecAgency')"
          />
          <label for="preinspectionlinkcustomer" class="custom-control-label labelstyle1" :disabled="!((pinStatus == 'PIN Generated, Agency Alloted' || pinStatus == '') && fetchedType!='allocToInspecAgency')">
            <span class="selfInspection">Send Inspection Link to Customer</span>
          </label>
        </div>
        <!--Send Inspection Link to Customer ends-->
        <!--Self inspection by IMD starts -->
        <div v-if="selfInspectionFlag=='Y'" class="form-group col-lg-3 col-md-5 col-sm-6 p-0" :disabled="!((pinStatus == 'PIN Generated, Agency Alloted' || pinStatus == '') && fetchedType!='allocToInspecAgency')" >
          <input
            type="radio"
            class="input-radio bgc-radio"
            name="preInspecType"
            id="preInspectionImd"
            v-model="inspectionData.typeOfInspection"
            value="selfInspectionByImd"
            :disabled="!((pinStatus == 'PIN Generated, Agency Alloted' || pinStatus == '') && fetchedType!='allocToInspecAgency')"
          />
          <label for="preInspectionImd" class="custom-control-label labelstyle1">
            <span class="selfInspection">Self inspection by IMD</span>
          </label>
        </div>
        <!--Self inspection by IMD ends-->
        <!-- Allocation to Inspection Agency starts-->
        <div class="form-group col-lg-3 col-md-5 col-sm-6 p-0" :disabled="!((pinStatus == 'PIN Generated, Agency Alloted' || pinStatus == '') && fetchedType!='allocToInspecAgency')">
          <input
            type="radio"
            class="input-radio bgc-radio"
            name="preInspecType"
            id="preInspectionAgency"
            v-model="inspectionData.typeOfInspection"
            value="allocToInspecAgency"
          />
          <label for="preInspectionAgency" class="custom-control-label labelstyle1">
            <span class="selfInspection">Allocation to Inspection Agency</span>
          </label>
        </div>
        <!-- Allocation to Inspection Agency ends-->
      </div>
      <div class="row">
        <!--User Remark starts-->
        <div class="form-group col-lg-6 col-md-6 col-sm-6 p-0 pb-4">
          <float-label label="Remarks">
            <textarea
              type="text"
              rows="4"
              cols="30"
              class="form-control"
              placeholder="Remarks"
              v-model="inspectionData.userRemark"
            ></textarea>
          </float-label>
        </div>
        <!--User Remark ends-->
      </div>  
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from '@/../../masters/functions.js';
import RadialProgressBar from 'vue-radial-progress'; 
import { reactive, computed } from '@vue/composition-api';
import moment from 'moment';

export default {
  name: "InspectionDetails",
  props: ["inspectionData","inspectionTypeList","isModify","inspectionOptionData","fetchedType","pinStatus","selfInspectionFlag"],
  components: {
    FloatLabel,
    Datepicker,
    RadialProgressBar
  },
  setup(props){
      let state = reactive({
          customerProgressBar : {
          startColor : '#007bff',
          stopColor: '#007bff',
          innerStrokeColor: '#D3D3D3'
        } 
      });
      //computed
      const totalSteps = computed(()=>{
          return 2;
      });
      const disablePastYears = computed(()=> {
      return {
          to: moment(new Date()).startOf('day').toDate(),
      }
    })
      const completedSteps = computed(()=>{
          let count = 0;
          if(props.inspectionData.inspectionType.value!='' && props.inspectionData.inspectionType.errorText =='') 
            count++;
          if(props.inspectionData.inspectionPlanDate.value!='' && props.inspectionData.inspectionPlanDate.value!=null && props.inspectionData.inspectionPlanDate.errorText =='') 
            count++;
          return count;
      });
      //methods
      const onlyNumber = functions.onlyNumber;
      const isFloat= functions.isFloat;
      const checkError= functions.checkError;
      const removeErrorIfNotBlank= functions.removeErrorIfNotBlank;
      const isInputError= functions.isInputError;

      return{
        state,
        totalSteps,
        completedSteps,
        onlyNumber,
        isFloat,
        checkError,
        removeErrorIfNotBlank,
        isInputError,
        disablePastYears
      }
  },
  directives: {
    evolvews: functions.evolvews
  }
};
</script>
<style scoped>
.flex-item {
  display: flex;
}
.input-checkbox {
  margin-left: 15px;
}
input[type="checkbox"].bgc-checkbox {
  position: relative;
  left: 19px;
  top: 3px;
}
input[type="radio"].bgc-radio {
  z-index: 5;
  padding: 3px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

input[type="radio"].bgc-radio + label::before {
  top: 0px;
  left: -30px;
  cursor: default;
  height: 21px;
  width: 21px;
}
.custom-control-label::after{
  z-index: -1;
}
.labelstyle1 {
  font-size: 11px;
  display: flex;
  color: darkgrey;
  font-family: inherit;
  margin-left: 2px;
  margin-top: 5px;
  position: relative;
  right: 16px;
  word-break: break-all;
}
input[type=radio].bgc-radio:checked + label::before{
  line-height: 20px;
}
span.selfInspection {
  font-size: 14px;
  color: #495057;
  padding-left: 10px;
}
@media (max-width: 978px) and (min-width: 768px) {
  span.selfInspection{
    padding-left: 0px;
    word-break: break-all; 
  }
}
</style>